import React from "react";
export const ScanAuditTimeline = ({ entries = [], dataTestId = "rl-scan-audit-timeline" }) => {
  const items = Array.isArray(entries) ? entries : [];
  if (!items.length) return <div data-testid={`${dataTestId}-empty`} className="rounded-md border border-dashed border-slate-300 p-4 text-xs text-slate-500">No scans yet.</div>;
  return (
    <ol data-testid={dataTestId} className="relative ml-2 space-y-3 border-l border-slate-200 pl-4">
      {items.map((e, i) => (
        <li key={i} data-testid={`${dataTestId}-entry-${i}`} className="relative">
          <span className="absolute -left-[21px] top-1.5 h-2.5 w-2.5 rounded-full bg-sky-500" />
          <div className="flex flex-wrap items-baseline gap-2 text-xs">
            <code className="rounded bg-slate-100 px-1 py-0.5">{e.scanner_role || "—"}</code>
            <span className={`rounded px-1 py-0.5 text-[10px] font-medium ${e.result === "ok" ? "bg-emerald-100 text-emerald-800" : "bg-rose-100 text-rose-800"}`}>
              {e.result || "—"}
            </span>
            <span className="text-slate-500">{e.at?.slice(0, 19).replace("T", " ") || ""}</span>
          </div>
          {(e.cross_org || e.cross_shop) && (
            <p className="mt-0.5 text-[10px] text-amber-700">
              {e.cross_org ? "cross-org " : ""}{e.cross_shop ? "cross-shop" : ""}
            </p>
          )}
          {e.scanner_user_id && (
            <p className="mt-0.5 text-[10px] text-slate-400">by <code>{String(e.scanner_user_id).slice(0, 12)}</code></p>
          )}
        </li>
      ))}
    </ol>
  );
};
export default ScanAuditTimeline;
